<template>
  <div ref = "scroll" class = "api-module api-console">
    <ul ref = "list">
      <li v-for = "m in console" :key = "m.time">{{m.msg}}</li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'ApiConsole',
  components: {
  },
  props: {
  },
  data () {
    return {
      messages: [
      ]
    }
  },
  computed: {
    console () {
      return this.$store.state.console
    }
  },
  methods: {
  },
  mounted () {
  },
  updated () {
    // console.log('updated')
    this.$refs.scroll.scrollTop = this.$refs.list.clientHeight
  }
}
</script>

<style lang = "less" scoped>
@import (reference) "../../assets/styles/main.less";

.api-console {
  background: @backgroundConsole;
  color: @secondaryTextColor;
  overflow-y: auto;

  ul {
    font-family: monospace;

    li {
      padding: 5px 8px;
      border-bottom: 1px dotted #111;

      &:nth-child(even) {
        background: #fff1;
      }
    }
  }
}

</style>



// WEBPACK FOOTER //
// src/components/ApiModules/ApiConsole.vue